/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_TitlesInputs */



/**
* | output |
* | --- |
* | "TITLES" |
*
* @param {Ccsl_Export_Header_TitlesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_titles = /** @type {((inputs?: Ccsl_Export_Header_TitlesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_TitlesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("TITRES")
	if (locale === "de") return /** @type {LocalizedString} */ ("TITEL")
	if (locale === "it") return /** @type {LocalizedString} */ ("TITOLI")
	if (locale === "ru") return /** @type {LocalizedString} */ ("НАЗВАНИЯ")
	if (locale === "es") return /** @type {LocalizedString} */ ("TÍTULOS")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("标题")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイトル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("खिताब")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("TÍTULOS")
	return /** @type {LocalizedString} */ ("TITLES")
});